import { MASTHEAD_LAYOUT, type MastheadLayoutId } from '@/lib/category-masthead-layout'
import { cn } from '@/lib/utils'

const bar = 'animate-pulse rounded-[5px] bg-gray-200 dark:bg-slate-700'

function SideList({ count = 4 }: { count?: number }) {
  return (
    <div className="hidden flex-col gap-3 lg:flex">
      {Array.from({ length: count }, (_, i) => (
        <div key={i} className="flex gap-3">
          <div className={cn(bar, 'h-16 w-24 shrink-0')} />
          <div className="flex flex-1 flex-col justify-center gap-2">
            <div className={cn(bar, 'h-3 w-full')} />
            <div className={cn(bar, 'h-3 w-4/5')} />
          </div>
        </div>
      ))}
    </div>
  )
}

function SideCards({ count = 2 }: { count?: number }) {
  return (
    <div className="hidden flex-col gap-3 lg:flex">
      {Array.from({ length: count }, (_, i) => (
        <div key={i} className={cn(bar, 'min-h-[8.5rem] w-full flex-1')} />
      ))}
    </div>
  )
}

/** Gerçek manşet layout’larıyla birebir iskelet */
export default function MastheadLayoutSkeleton({
  layout,
  className = '',
}: {
  layout: MastheadLayoutId
  className?: string
}) {
  if (layout === MASTHEAD_LAYOUT.GRID) {
    return (
      <div
        className={cn(
          'mb-6 grid min-w-0 grid-cols-1 gap-3.5 sm:grid-cols-2 sm:gap-4 lg:grid-cols-[minmax(0,1.2fr)_minmax(0,1fr)_minmax(0,1fr)] lg:grid-rows-2 lg:gap-5 lg:min-h-[32rem]',
          className,
        )}
      >
        <div className={cn(bar, 'min-h-[260px] sm:col-span-2 sm:min-h-[300px] lg:col-span-1 lg:row-span-2 lg:min-h-full')} />
        {Array.from({ length: 4 }, (_, i) => (
          <div key={i} className={cn(bar, 'min-h-[8.5rem] w-full')} />
        ))}
      </div>
    )
  }

  if (layout === MASTHEAD_LAYOUT.CENTER_SIDES) {
    return (
      <div className={cn('mb-6 space-y-3', className)}>
        <div className={cn(bar, 'aspect-[9/5] w-full lg:hidden')} />
        <div className="hidden lg:grid lg:grid-cols-[minmax(0,1fr)_minmax(0,2.15fr)_minmax(0,1fr)] lg:grid-rows-2 lg:gap-3">
          <div className={cn(bar, 'col-start-1 row-start-1 min-h-[7.5rem]')} />
          <div className={cn(bar, 'col-start-1 row-start-2 min-h-[7.5rem]')} />
          <div className={cn(bar, 'col-start-2 row-span-2 min-h-[16rem] md:min-h-[450px]')} />
          <div className={cn(bar, 'col-start-3 row-start-1 min-h-[7.5rem]')} />
          <div className={cn(bar, 'col-start-3 row-start-2 min-h-[7.5rem]')} />
        </div>
      </div>
    )
  }

  if (layout === MASTHEAD_LAYOUT.SLIDER_RIGHT) {
    return (
      <div
        className={cn(
          'mb-6 grid min-w-0 grid-cols-1 gap-3.5 lg:grid-cols-[minmax(0,1.65fr)_minmax(0,0.86fr)] lg:items-stretch lg:gap-5',
          className,
        )}
      >
        <div className={cn(bar, 'aspect-[9/5] w-full lg:aspect-auto lg:min-h-[22rem]')} />
        <SideCards count={2} />
      </div>
    )
  }

  if (layout === MASTHEAD_LAYOUT.SLIDER_SIDEBAR) {
    return (
      <div
        className={cn(
          'mb-6 grid gap-3 lg:grid-cols-[minmax(0,1.7fr)_minmax(0,1fr)]',
          className,
        )}
      >
        <div className={cn(bar, 'aspect-[9/5] w-full')} />
        <SideList count={4} />
      </div>
    )
  }

  if (layout === MASTHEAD_LAYOUT.COMPACT_SLIDER) {
    return (
      <div className={cn('mb-6', className)}>
        <div className={cn(bar, 'aspect-[16/9] w-full')} />
      </div>
    )
  }

  // SLIDER (tam)
  return (
    <div className={cn('mb-6', className)}>
      <div className={cn(bar, 'aspect-[9/5] w-full md:aspect-auto md:min-h-[450px]')} />
    </div>
  )
}
